import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type ReceiveVendorPurchaseOrderItemsMutationVariables = Types.Exact<{
  input: Types.ReceiveVendorPurchaseOrderItemsInput;
}>;


export type ReceiveVendorPurchaseOrderItemsMutation = { __typename?: 'Mutation', receiveVendorPurchaseOrderItems: { __typename?: 'VendorPurchaseOrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, vendorPurchaseOrder?: { __typename?: 'VendorPurchaseOrderDocument', created: Types.TDateISO, erpId: string, id: string, orderPlacedDate: Types.TDateISO, purchaseOrderNumber: string, siteLocationId: string, status: Types.VendorPurchaseOrderStatus, tenantId: string, updated: Types.TDateISO, vendorId: string, vendorName: string, isUrgent: boolean, estimatedSubtotal: number, estimatedTotal: number, needByDate?: string | null, shipWeek?: number | null, notes: string, billingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, shippingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, items: Array<{ __typename?: 'VendorPurchaseOrderItemData', erpJobId: string, eventDetailId?: string | null, id: string, isCostOverridden: boolean, isOrganicAtReceive: boolean, itemName: string, lineNumber: number, materialItemErpId: string, materialItemId: string, organicLotCode?: string | null, productionJobId?: string | null, productionJobNumber?: number | null, quantityOrdered: number, quantityReceived: number, unitCost?: number | null, unitCostText?: string | null, varianceReason: Types.VendorReceiveVarianceReason }>, charges: Array<{ __typename?: 'VendorPurchaseOrderChargeData', id: string, label: string, amount: number }> } | null } };

export type CreateVendorPurchaseOrderMutationVariables = Types.Exact<{
  input: Types.CreateVendorPurchaseOrderInput;
}>;


export type CreateVendorPurchaseOrderMutation = { __typename?: 'Mutation', createVendorPurchaseOrder: { __typename?: 'VendorPurchaseOrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, vendorPurchaseOrder?: { __typename?: 'VendorPurchaseOrderDocument', created: Types.TDateISO, erpId: string, id: string, orderPlacedDate: Types.TDateISO, purchaseOrderNumber: string, siteLocationId: string, status: Types.VendorPurchaseOrderStatus, tenantId: string, updated: Types.TDateISO, vendorId: string, vendorName: string, isUrgent: boolean, estimatedSubtotal: number, estimatedTotal: number, needByDate?: string | null, shipWeek?: number | null, notes: string, billingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, shippingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, items: Array<{ __typename?: 'VendorPurchaseOrderItemData', erpJobId: string, eventDetailId?: string | null, id: string, isCostOverridden: boolean, isOrganicAtReceive: boolean, itemName: string, lineNumber: number, materialItemErpId: string, materialItemId: string, organicLotCode?: string | null, productionJobId?: string | null, productionJobNumber?: number | null, quantityOrdered: number, quantityReceived: number, unitCost?: number | null, unitCostText?: string | null, varianceReason: Types.VendorReceiveVarianceReason }>, charges: Array<{ __typename?: 'VendorPurchaseOrderChargeData', id: string, label: string, amount: number }> } | null } };

export type SetPurchaseOrderUrgentMutationVariables = Types.Exact<{
  input: Types.SetPurchaseOrderUrgentInput;
}>;


export type SetPurchaseOrderUrgentMutation = { __typename?: 'Mutation', setPurchaseOrderUrgent: { __typename?: 'VendorPurchaseOrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, vendorPurchaseOrder?: { __typename?: 'VendorPurchaseOrderDocument', created: Types.TDateISO, erpId: string, id: string, orderPlacedDate: Types.TDateISO, purchaseOrderNumber: string, siteLocationId: string, status: Types.VendorPurchaseOrderStatus, tenantId: string, updated: Types.TDateISO, vendorId: string, vendorName: string, isUrgent: boolean, estimatedSubtotal: number, estimatedTotal: number, needByDate?: string | null, shipWeek?: number | null, notes: string, billingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, shippingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, items: Array<{ __typename?: 'VendorPurchaseOrderItemData', erpJobId: string, eventDetailId?: string | null, id: string, isCostOverridden: boolean, isOrganicAtReceive: boolean, itemName: string, lineNumber: number, materialItemErpId: string, materialItemId: string, organicLotCode?: string | null, productionJobId?: string | null, productionJobNumber?: number | null, quantityOrdered: number, quantityReceived: number, unitCost?: number | null, unitCostText?: string | null, varianceReason: Types.VendorReceiveVarianceReason }>, charges: Array<{ __typename?: 'VendorPurchaseOrderChargeData', id: string, label: string, amount: number }> } | null } };

export type UpdateVendorPurchaseOrderSiteLocationMutationVariables = Types.Exact<{
  input: Types.UpdateVendorPurchaseOrderSiteLocationInput;
}>;


export type UpdateVendorPurchaseOrderSiteLocationMutation = { __typename?: 'Mutation', updateVendorPurchaseOrderSiteLocation: { __typename?: 'VendorPurchaseOrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, vendorPurchaseOrder?: { __typename?: 'VendorPurchaseOrderDocument', created: Types.TDateISO, erpId: string, id: string, orderPlacedDate: Types.TDateISO, purchaseOrderNumber: string, siteLocationId: string, status: Types.VendorPurchaseOrderStatus, tenantId: string, updated: Types.TDateISO, vendorId: string, vendorName: string, isUrgent: boolean, estimatedSubtotal: number, estimatedTotal: number, needByDate?: string | null, shipWeek?: number | null, notes: string, billingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, shippingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, items: Array<{ __typename?: 'VendorPurchaseOrderItemData', erpJobId: string, eventDetailId?: string | null, id: string, isCostOverridden: boolean, isOrganicAtReceive: boolean, itemName: string, lineNumber: number, materialItemErpId: string, materialItemId: string, organicLotCode?: string | null, productionJobId?: string | null, productionJobNumber?: number | null, quantityOrdered: number, quantityReceived: number, unitCost?: number | null, unitCostText?: string | null, varianceReason: Types.VendorReceiveVarianceReason }>, charges: Array<{ __typename?: 'VendorPurchaseOrderChargeData', id: string, label: string, amount: number }> } | null } };

export type ApprovePurchaseOrderMutationVariables = Types.Exact<{
  input: Types.ApprovePurchaseOrderInput;
}>;


export type ApprovePurchaseOrderMutation = { __typename?: 'Mutation', approvePurchaseOrder: { __typename?: 'VendorPurchaseOrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, vendorPurchaseOrder?: { __typename?: 'VendorPurchaseOrderDocument', created: Types.TDateISO, erpId: string, id: string, orderPlacedDate: Types.TDateISO, purchaseOrderNumber: string, siteLocationId: string, status: Types.VendorPurchaseOrderStatus, tenantId: string, updated: Types.TDateISO, vendorId: string, vendorName: string, isUrgent: boolean, estimatedSubtotal: number, estimatedTotal: number, needByDate?: string | null, shipWeek?: number | null, notes: string, billingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, shippingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, items: Array<{ __typename?: 'VendorPurchaseOrderItemData', erpJobId: string, eventDetailId?: string | null, id: string, isCostOverridden: boolean, isOrganicAtReceive: boolean, itemName: string, lineNumber: number, materialItemErpId: string, materialItemId: string, organicLotCode?: string | null, productionJobId?: string | null, productionJobNumber?: number | null, quantityOrdered: number, quantityReceived: number, unitCost?: number | null, unitCostText?: string | null, varianceReason: Types.VendorReceiveVarianceReason }>, charges: Array<{ __typename?: 'VendorPurchaseOrderChargeData', id: string, label: string, amount: number }> } | null } };

export type ShipPurchaseOrderMutationVariables = Types.Exact<{
  input: Types.ShipPurchaseOrderInput;
}>;


export type ShipPurchaseOrderMutation = { __typename?: 'Mutation', shipPurchaseOrder: { __typename?: 'VendorPurchaseOrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, vendorPurchaseOrder?: { __typename?: 'VendorPurchaseOrderDocument', created: Types.TDateISO, erpId: string, id: string, orderPlacedDate: Types.TDateISO, purchaseOrderNumber: string, siteLocationId: string, status: Types.VendorPurchaseOrderStatus, tenantId: string, updated: Types.TDateISO, vendorId: string, vendorName: string, isUrgent: boolean, estimatedSubtotal: number, estimatedTotal: number, needByDate?: string | null, shipWeek?: number | null, notes: string, billingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, shippingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, items: Array<{ __typename?: 'VendorPurchaseOrderItemData', erpJobId: string, eventDetailId?: string | null, id: string, isCostOverridden: boolean, isOrganicAtReceive: boolean, itemName: string, lineNumber: number, materialItemErpId: string, materialItemId: string, organicLotCode?: string | null, productionJobId?: string | null, productionJobNumber?: number | null, quantityOrdered: number, quantityReceived: number, unitCost?: number | null, unitCostText?: string | null, varianceReason: Types.VendorReceiveVarianceReason }>, charges: Array<{ __typename?: 'VendorPurchaseOrderChargeData', id: string, label: string, amount: number }> } | null } };

export type CancelPurchaseOrderMutationVariables = Types.Exact<{
  input: Types.CancelPurchaseOrderInput;
}>;


export type CancelPurchaseOrderMutation = { __typename?: 'Mutation', cancelPurchaseOrder: { __typename?: 'VendorPurchaseOrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, vendorPurchaseOrder?: { __typename?: 'VendorPurchaseOrderDocument', created: Types.TDateISO, erpId: string, id: string, orderPlacedDate: Types.TDateISO, purchaseOrderNumber: string, siteLocationId: string, status: Types.VendorPurchaseOrderStatus, tenantId: string, updated: Types.TDateISO, vendorId: string, vendorName: string, isUrgent: boolean, estimatedSubtotal: number, estimatedTotal: number, needByDate?: string | null, shipWeek?: number | null, notes: string, billingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, shippingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, items: Array<{ __typename?: 'VendorPurchaseOrderItemData', erpJobId: string, eventDetailId?: string | null, id: string, isCostOverridden: boolean, isOrganicAtReceive: boolean, itemName: string, lineNumber: number, materialItemErpId: string, materialItemId: string, organicLotCode?: string | null, productionJobId?: string | null, productionJobNumber?: number | null, quantityOrdered: number, quantityReceived: number, unitCost?: number | null, unitCostText?: string | null, varianceReason: Types.VendorReceiveVarianceReason }>, charges: Array<{ __typename?: 'VendorPurchaseOrderChargeData', id: string, label: string, amount: number }> } | null } };

export type ChangeVendorPurchaseOrderStatusMutationVariables = Types.Exact<{
  input: Types.ChangeVendorPurchaseOrderStatusInput;
}>;


export type ChangeVendorPurchaseOrderStatusMutation = { __typename?: 'Mutation', changeVendorPurchaseOrderStatus: { __typename?: 'VendorPurchaseOrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, vendorPurchaseOrder?: { __typename?: 'VendorPurchaseOrderDocument', created: Types.TDateISO, erpId: string, id: string, orderPlacedDate: Types.TDateISO, purchaseOrderNumber: string, siteLocationId: string, status: Types.VendorPurchaseOrderStatus, tenantId: string, updated: Types.TDateISO, vendorId: string, vendorName: string, isUrgent: boolean, estimatedSubtotal: number, estimatedTotal: number, needByDate?: string | null, shipWeek?: number | null, notes: string, billingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, shippingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, items: Array<{ __typename?: 'VendorPurchaseOrderItemData', erpJobId: string, eventDetailId?: string | null, id: string, isCostOverridden: boolean, isOrganicAtReceive: boolean, itemName: string, lineNumber: number, materialItemErpId: string, materialItemId: string, organicLotCode?: string | null, productionJobId?: string | null, productionJobNumber?: number | null, quantityOrdered: number, quantityReceived: number, unitCost?: number | null, unitCostText?: string | null, varianceReason: Types.VendorReceiveVarianceReason }>, charges: Array<{ __typename?: 'VendorPurchaseOrderChargeData', id: string, label: string, amount: number }> } | null } };

export type AddPurchaseOrderLineItemMutationVariables = Types.Exact<{
  input: Types.AddPurchaseOrderLineItemInput;
}>;


export type AddPurchaseOrderLineItemMutation = { __typename?: 'Mutation', addPurchaseOrderLineItem: { __typename?: 'VendorPurchaseOrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, vendorPurchaseOrder?: { __typename?: 'VendorPurchaseOrderDocument', created: Types.TDateISO, erpId: string, id: string, orderPlacedDate: Types.TDateISO, purchaseOrderNumber: string, siteLocationId: string, status: Types.VendorPurchaseOrderStatus, tenantId: string, updated: Types.TDateISO, vendorId: string, vendorName: string, isUrgent: boolean, estimatedSubtotal: number, estimatedTotal: number, needByDate?: string | null, shipWeek?: number | null, notes: string, billingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, shippingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, items: Array<{ __typename?: 'VendorPurchaseOrderItemData', erpJobId: string, eventDetailId?: string | null, id: string, isCostOverridden: boolean, isOrganicAtReceive: boolean, itemName: string, lineNumber: number, materialItemErpId: string, materialItemId: string, organicLotCode?: string | null, productionJobId?: string | null, productionJobNumber?: number | null, quantityOrdered: number, quantityReceived: number, unitCost?: number | null, unitCostText?: string | null, varianceReason: Types.VendorReceiveVarianceReason }>, charges: Array<{ __typename?: 'VendorPurchaseOrderChargeData', id: string, label: string, amount: number }> } | null } };

export type AmendPurchaseOrderLineItemMutationVariables = Types.Exact<{
  input: Types.AmendPurchaseOrderLineItemInput;
}>;


export type AmendPurchaseOrderLineItemMutation = { __typename?: 'Mutation', amendPurchaseOrderLineItem: { __typename?: 'VendorPurchaseOrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, vendorPurchaseOrder?: { __typename?: 'VendorPurchaseOrderDocument', created: Types.TDateISO, erpId: string, id: string, orderPlacedDate: Types.TDateISO, purchaseOrderNumber: string, siteLocationId: string, status: Types.VendorPurchaseOrderStatus, tenantId: string, updated: Types.TDateISO, vendorId: string, vendorName: string, isUrgent: boolean, estimatedSubtotal: number, estimatedTotal: number, needByDate?: string | null, shipWeek?: number | null, notes: string, billingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, shippingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, items: Array<{ __typename?: 'VendorPurchaseOrderItemData', erpJobId: string, eventDetailId?: string | null, id: string, isCostOverridden: boolean, isOrganicAtReceive: boolean, itemName: string, lineNumber: number, materialItemErpId: string, materialItemId: string, organicLotCode?: string | null, productionJobId?: string | null, productionJobNumber?: number | null, quantityOrdered: number, quantityReceived: number, unitCost?: number | null, unitCostText?: string | null, varianceReason: Types.VendorReceiveVarianceReason }>, charges: Array<{ __typename?: 'VendorPurchaseOrderChargeData', id: string, label: string, amount: number }> } | null } };

export type RemovePurchaseOrderLineItemMutationVariables = Types.Exact<{
  input: Types.RemovePurchaseOrderLineItemInput;
}>;


export type RemovePurchaseOrderLineItemMutation = { __typename?: 'Mutation', removePurchaseOrderLineItem: { __typename?: 'VendorPurchaseOrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, vendorPurchaseOrder?: { __typename?: 'VendorPurchaseOrderDocument', created: Types.TDateISO, erpId: string, id: string, orderPlacedDate: Types.TDateISO, purchaseOrderNumber: string, siteLocationId: string, status: Types.VendorPurchaseOrderStatus, tenantId: string, updated: Types.TDateISO, vendorId: string, vendorName: string, isUrgent: boolean, estimatedSubtotal: number, estimatedTotal: number, needByDate?: string | null, shipWeek?: number | null, notes: string, billingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, shippingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, items: Array<{ __typename?: 'VendorPurchaseOrderItemData', erpJobId: string, eventDetailId?: string | null, id: string, isCostOverridden: boolean, isOrganicAtReceive: boolean, itemName: string, lineNumber: number, materialItemErpId: string, materialItemId: string, organicLotCode?: string | null, productionJobId?: string | null, productionJobNumber?: number | null, quantityOrdered: number, quantityReceived: number, unitCost?: number | null, unitCostText?: string | null, varianceReason: Types.VendorReceiveVarianceReason }>, charges: Array<{ __typename?: 'VendorPurchaseOrderChargeData', id: string, label: string, amount: number }> } | null } };

export type ConfirmReceiptMutationVariables = Types.Exact<{
  input: Types.ConfirmReceiptInput;
}>;


export type ConfirmReceiptMutation = { __typename?: 'Mutation', confirmReceipt: { __typename?: 'VendorPurchaseOrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, vendorPurchaseOrder?: { __typename?: 'VendorPurchaseOrderDocument', created: Types.TDateISO, erpId: string, id: string, orderPlacedDate: Types.TDateISO, purchaseOrderNumber: string, siteLocationId: string, status: Types.VendorPurchaseOrderStatus, tenantId: string, updated: Types.TDateISO, vendorId: string, vendorName: string, isUrgent: boolean, estimatedSubtotal: number, estimatedTotal: number, needByDate?: string | null, shipWeek?: number | null, notes: string, billingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, shippingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, items: Array<{ __typename?: 'VendorPurchaseOrderItemData', erpJobId: string, eventDetailId?: string | null, id: string, isCostOverridden: boolean, isOrganicAtReceive: boolean, itemName: string, lineNumber: number, materialItemErpId: string, materialItemId: string, organicLotCode?: string | null, productionJobId?: string | null, productionJobNumber?: number | null, quantityOrdered: number, quantityReceived: number, unitCost?: number | null, unitCostText?: string | null, varianceReason: Types.VendorReceiveVarianceReason }>, charges: Array<{ __typename?: 'VendorPurchaseOrderChargeData', id: string, label: string, amount: number }> } | null } };

export type AddVendorPurchaseOrderChargeMutationVariables = Types.Exact<{
  input: Types.AddVendorPurchaseOrderChargeInput;
}>;


export type AddVendorPurchaseOrderChargeMutation = { __typename?: 'Mutation', addVendorPurchaseOrderCharge: { __typename?: 'VendorPurchaseOrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, vendorPurchaseOrder?: { __typename?: 'VendorPurchaseOrderDocument', created: Types.TDateISO, erpId: string, id: string, orderPlacedDate: Types.TDateISO, purchaseOrderNumber: string, siteLocationId: string, status: Types.VendorPurchaseOrderStatus, tenantId: string, updated: Types.TDateISO, vendorId: string, vendorName: string, isUrgent: boolean, estimatedSubtotal: number, estimatedTotal: number, needByDate?: string | null, shipWeek?: number | null, notes: string, billingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, shippingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, items: Array<{ __typename?: 'VendorPurchaseOrderItemData', erpJobId: string, eventDetailId?: string | null, id: string, isCostOverridden: boolean, isOrganicAtReceive: boolean, itemName: string, lineNumber: number, materialItemErpId: string, materialItemId: string, organicLotCode?: string | null, productionJobId?: string | null, productionJobNumber?: number | null, quantityOrdered: number, quantityReceived: number, unitCost?: number | null, unitCostText?: string | null, varianceReason: Types.VendorReceiveVarianceReason }>, charges: Array<{ __typename?: 'VendorPurchaseOrderChargeData', id: string, label: string, amount: number }> } | null } };

export type RemoveVendorPurchaseOrderChargeMutationVariables = Types.Exact<{
  input: Types.RemoveVendorPurchaseOrderChargeInput;
}>;


export type RemoveVendorPurchaseOrderChargeMutation = { __typename?: 'Mutation', removeVendorPurchaseOrderCharge: { __typename?: 'VendorPurchaseOrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, vendorPurchaseOrder?: { __typename?: 'VendorPurchaseOrderDocument', created: Types.TDateISO, erpId: string, id: string, orderPlacedDate: Types.TDateISO, purchaseOrderNumber: string, siteLocationId: string, status: Types.VendorPurchaseOrderStatus, tenantId: string, updated: Types.TDateISO, vendorId: string, vendorName: string, isUrgent: boolean, estimatedSubtotal: number, estimatedTotal: number, needByDate?: string | null, shipWeek?: number | null, notes: string, billingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, shippingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, items: Array<{ __typename?: 'VendorPurchaseOrderItemData', erpJobId: string, eventDetailId?: string | null, id: string, isCostOverridden: boolean, isOrganicAtReceive: boolean, itemName: string, lineNumber: number, materialItemErpId: string, materialItemId: string, organicLotCode?: string | null, productionJobId?: string | null, productionJobNumber?: number | null, quantityOrdered: number, quantityReceived: number, unitCost?: number | null, unitCostText?: string | null, varianceReason: Types.VendorReceiveVarianceReason }>, charges: Array<{ __typename?: 'VendorPurchaseOrderChargeData', id: string, label: string, amount: number }> } | null } };

export type UpdateVendorPurchaseOrderMetadataMutationVariables = Types.Exact<{
  input: Types.UpdateVendorPurchaseOrderMetadataInput;
}>;


export type UpdateVendorPurchaseOrderMetadataMutation = { __typename?: 'Mutation', updateVendorPurchaseOrderMetadata: { __typename?: 'VendorPurchaseOrderPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, vendorPurchaseOrder?: { __typename?: 'VendorPurchaseOrderDocument', created: Types.TDateISO, erpId: string, id: string, orderPlacedDate: Types.TDateISO, purchaseOrderNumber: string, siteLocationId: string, status: Types.VendorPurchaseOrderStatus, tenantId: string, updated: Types.TDateISO, vendorId: string, vendorName: string, isUrgent: boolean, estimatedSubtotal: number, estimatedTotal: number, needByDate?: string | null, shipWeek?: number | null, notes: string, billingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, shippingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, items: Array<{ __typename?: 'VendorPurchaseOrderItemData', erpJobId: string, eventDetailId?: string | null, id: string, isCostOverridden: boolean, isOrganicAtReceive: boolean, itemName: string, lineNumber: number, materialItemErpId: string, materialItemId: string, organicLotCode?: string | null, productionJobId?: string | null, productionJobNumber?: number | null, quantityOrdered: number, quantityReceived: number, unitCost?: number | null, unitCostText?: string | null, varianceReason: Types.VendorReceiveVarianceReason }>, charges: Array<{ __typename?: 'VendorPurchaseOrderChargeData', id: string, label: string, amount: number }> } | null } };


export const ReceiveVendorPurchaseOrderItemsDocument = new TypedDocumentString(`
    mutation ReceiveVendorPurchaseOrderItems($input: ReceiveVendorPurchaseOrderItemsInput!) {
  receiveVendorPurchaseOrderItems(input: $input) {
    errors {
      code
      message
    }
    vendorPurchaseOrder {
      ...VendorPurchaseOrderFields
    }
  }
}
    fragment VendorPurchaseOrderFields on VendorPurchaseOrderDocument {
  created
  erpId
  id
  orderPlacedDate
  purchaseOrderNumber
  siteLocationId
  status
  tenantId
  updated
  vendorId
  vendorName
  isUrgent
  estimatedSubtotal
  estimatedTotal
  needByDate
  shipWeek
  notes
  billingAddress {
    ...AddressData
  }
  shippingAddress {
    ...AddressData
  }
  items {
    ...VendorPurchaseOrderItemFields
  }
  charges {
    ...VendorPurchaseOrderChargeFields
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment VendorPurchaseOrderItemFields on VendorPurchaseOrderItemData {
  erpJobId
  eventDetailId
  id
  isCostOverridden
  isOrganicAtReceive
  itemName
  lineNumber
  materialItemErpId
  materialItemId
  organicLotCode
  productionJobId
  productionJobNumber
  quantityOrdered
  quantityReceived
  unitCost
  unitCostText
  varianceReason
}
fragment VendorPurchaseOrderChargeFields on VendorPurchaseOrderChargeData {
  id
  label
  amount
}`);
export const CreateVendorPurchaseOrderDocument = new TypedDocumentString(`
    mutation CreateVendorPurchaseOrder($input: CreateVendorPurchaseOrderInput!) {
  createVendorPurchaseOrder(input: $input) {
    errors {
      code
      message
    }
    vendorPurchaseOrder {
      ...VendorPurchaseOrderFields
    }
  }
}
    fragment VendorPurchaseOrderFields on VendorPurchaseOrderDocument {
  created
  erpId
  id
  orderPlacedDate
  purchaseOrderNumber
  siteLocationId
  status
  tenantId
  updated
  vendorId
  vendorName
  isUrgent
  estimatedSubtotal
  estimatedTotal
  needByDate
  shipWeek
  notes
  billingAddress {
    ...AddressData
  }
  shippingAddress {
    ...AddressData
  }
  items {
    ...VendorPurchaseOrderItemFields
  }
  charges {
    ...VendorPurchaseOrderChargeFields
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment VendorPurchaseOrderItemFields on VendorPurchaseOrderItemData {
  erpJobId
  eventDetailId
  id
  isCostOverridden
  isOrganicAtReceive
  itemName
  lineNumber
  materialItemErpId
  materialItemId
  organicLotCode
  productionJobId
  productionJobNumber
  quantityOrdered
  quantityReceived
  unitCost
  unitCostText
  varianceReason
}
fragment VendorPurchaseOrderChargeFields on VendorPurchaseOrderChargeData {
  id
  label
  amount
}`);
export const SetPurchaseOrderUrgentDocument = new TypedDocumentString(`
    mutation SetPurchaseOrderUrgent($input: SetPurchaseOrderUrgentInput!) {
  setPurchaseOrderUrgent(input: $input) {
    errors {
      code
      message
    }
    vendorPurchaseOrder {
      ...VendorPurchaseOrderFields
    }
  }
}
    fragment VendorPurchaseOrderFields on VendorPurchaseOrderDocument {
  created
  erpId
  id
  orderPlacedDate
  purchaseOrderNumber
  siteLocationId
  status
  tenantId
  updated
  vendorId
  vendorName
  isUrgent
  estimatedSubtotal
  estimatedTotal
  needByDate
  shipWeek
  notes
  billingAddress {
    ...AddressData
  }
  shippingAddress {
    ...AddressData
  }
  items {
    ...VendorPurchaseOrderItemFields
  }
  charges {
    ...VendorPurchaseOrderChargeFields
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment VendorPurchaseOrderItemFields on VendorPurchaseOrderItemData {
  erpJobId
  eventDetailId
  id
  isCostOverridden
  isOrganicAtReceive
  itemName
  lineNumber
  materialItemErpId
  materialItemId
  organicLotCode
  productionJobId
  productionJobNumber
  quantityOrdered
  quantityReceived
  unitCost
  unitCostText
  varianceReason
}
fragment VendorPurchaseOrderChargeFields on VendorPurchaseOrderChargeData {
  id
  label
  amount
}`);
export const UpdateVendorPurchaseOrderSiteLocationDocument = new TypedDocumentString(`
    mutation UpdateVendorPurchaseOrderSiteLocation($input: UpdateVendorPurchaseOrderSiteLocationInput!) {
  updateVendorPurchaseOrderSiteLocation(input: $input) {
    errors {
      code
      message
    }
    vendorPurchaseOrder {
      ...VendorPurchaseOrderFields
    }
  }
}
    fragment VendorPurchaseOrderFields on VendorPurchaseOrderDocument {
  created
  erpId
  id
  orderPlacedDate
  purchaseOrderNumber
  siteLocationId
  status
  tenantId
  updated
  vendorId
  vendorName
  isUrgent
  estimatedSubtotal
  estimatedTotal
  needByDate
  shipWeek
  notes
  billingAddress {
    ...AddressData
  }
  shippingAddress {
    ...AddressData
  }
  items {
    ...VendorPurchaseOrderItemFields
  }
  charges {
    ...VendorPurchaseOrderChargeFields
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment VendorPurchaseOrderItemFields on VendorPurchaseOrderItemData {
  erpJobId
  eventDetailId
  id
  isCostOverridden
  isOrganicAtReceive
  itemName
  lineNumber
  materialItemErpId
  materialItemId
  organicLotCode
  productionJobId
  productionJobNumber
  quantityOrdered
  quantityReceived
  unitCost
  unitCostText
  varianceReason
}
fragment VendorPurchaseOrderChargeFields on VendorPurchaseOrderChargeData {
  id
  label
  amount
}`);
export const ApprovePurchaseOrderDocument = new TypedDocumentString(`
    mutation ApprovePurchaseOrder($input: ApprovePurchaseOrderInput!) {
  approvePurchaseOrder(input: $input) {
    errors {
      code
      message
    }
    vendorPurchaseOrder {
      ...VendorPurchaseOrderFields
    }
  }
}
    fragment VendorPurchaseOrderFields on VendorPurchaseOrderDocument {
  created
  erpId
  id
  orderPlacedDate
  purchaseOrderNumber
  siteLocationId
  status
  tenantId
  updated
  vendorId
  vendorName
  isUrgent
  estimatedSubtotal
  estimatedTotal
  needByDate
  shipWeek
  notes
  billingAddress {
    ...AddressData
  }
  shippingAddress {
    ...AddressData
  }
  items {
    ...VendorPurchaseOrderItemFields
  }
  charges {
    ...VendorPurchaseOrderChargeFields
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment VendorPurchaseOrderItemFields on VendorPurchaseOrderItemData {
  erpJobId
  eventDetailId
  id
  isCostOverridden
  isOrganicAtReceive
  itemName
  lineNumber
  materialItemErpId
  materialItemId
  organicLotCode
  productionJobId
  productionJobNumber
  quantityOrdered
  quantityReceived
  unitCost
  unitCostText
  varianceReason
}
fragment VendorPurchaseOrderChargeFields on VendorPurchaseOrderChargeData {
  id
  label
  amount
}`);
export const ShipPurchaseOrderDocument = new TypedDocumentString(`
    mutation ShipPurchaseOrder($input: ShipPurchaseOrderInput!) {
  shipPurchaseOrder(input: $input) {
    errors {
      code
      message
    }
    vendorPurchaseOrder {
      ...VendorPurchaseOrderFields
    }
  }
}
    fragment VendorPurchaseOrderFields on VendorPurchaseOrderDocument {
  created
  erpId
  id
  orderPlacedDate
  purchaseOrderNumber
  siteLocationId
  status
  tenantId
  updated
  vendorId
  vendorName
  isUrgent
  estimatedSubtotal
  estimatedTotal
  needByDate
  shipWeek
  notes
  billingAddress {
    ...AddressData
  }
  shippingAddress {
    ...AddressData
  }
  items {
    ...VendorPurchaseOrderItemFields
  }
  charges {
    ...VendorPurchaseOrderChargeFields
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment VendorPurchaseOrderItemFields on VendorPurchaseOrderItemData {
  erpJobId
  eventDetailId
  id
  isCostOverridden
  isOrganicAtReceive
  itemName
  lineNumber
  materialItemErpId
  materialItemId
  organicLotCode
  productionJobId
  productionJobNumber
  quantityOrdered
  quantityReceived
  unitCost
  unitCostText
  varianceReason
}
fragment VendorPurchaseOrderChargeFields on VendorPurchaseOrderChargeData {
  id
  label
  amount
}`);
export const CancelPurchaseOrderDocument = new TypedDocumentString(`
    mutation CancelPurchaseOrder($input: CancelPurchaseOrderInput!) {
  cancelPurchaseOrder(input: $input) {
    errors {
      code
      message
    }
    vendorPurchaseOrder {
      ...VendorPurchaseOrderFields
    }
  }
}
    fragment VendorPurchaseOrderFields on VendorPurchaseOrderDocument {
  created
  erpId
  id
  orderPlacedDate
  purchaseOrderNumber
  siteLocationId
  status
  tenantId
  updated
  vendorId
  vendorName
  isUrgent
  estimatedSubtotal
  estimatedTotal
  needByDate
  shipWeek
  notes
  billingAddress {
    ...AddressData
  }
  shippingAddress {
    ...AddressData
  }
  items {
    ...VendorPurchaseOrderItemFields
  }
  charges {
    ...VendorPurchaseOrderChargeFields
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment VendorPurchaseOrderItemFields on VendorPurchaseOrderItemData {
  erpJobId
  eventDetailId
  id
  isCostOverridden
  isOrganicAtReceive
  itemName
  lineNumber
  materialItemErpId
  materialItemId
  organicLotCode
  productionJobId
  productionJobNumber
  quantityOrdered
  quantityReceived
  unitCost
  unitCostText
  varianceReason
}
fragment VendorPurchaseOrderChargeFields on VendorPurchaseOrderChargeData {
  id
  label
  amount
}`);
export const ChangeVendorPurchaseOrderStatusDocument = new TypedDocumentString(`
    mutation ChangeVendorPurchaseOrderStatus($input: ChangeVendorPurchaseOrderStatusInput!) {
  changeVendorPurchaseOrderStatus(input: $input) {
    errors {
      code
      message
    }
    vendorPurchaseOrder {
      ...VendorPurchaseOrderFields
    }
  }
}
    fragment VendorPurchaseOrderFields on VendorPurchaseOrderDocument {
  created
  erpId
  id
  orderPlacedDate
  purchaseOrderNumber
  siteLocationId
  status
  tenantId
  updated
  vendorId
  vendorName
  isUrgent
  estimatedSubtotal
  estimatedTotal
  needByDate
  shipWeek
  notes
  billingAddress {
    ...AddressData
  }
  shippingAddress {
    ...AddressData
  }
  items {
    ...VendorPurchaseOrderItemFields
  }
  charges {
    ...VendorPurchaseOrderChargeFields
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment VendorPurchaseOrderItemFields on VendorPurchaseOrderItemData {
  erpJobId
  eventDetailId
  id
  isCostOverridden
  isOrganicAtReceive
  itemName
  lineNumber
  materialItemErpId
  materialItemId
  organicLotCode
  productionJobId
  productionJobNumber
  quantityOrdered
  quantityReceived
  unitCost
  unitCostText
  varianceReason
}
fragment VendorPurchaseOrderChargeFields on VendorPurchaseOrderChargeData {
  id
  label
  amount
}`);
export const AddPurchaseOrderLineItemDocument = new TypedDocumentString(`
    mutation AddPurchaseOrderLineItem($input: AddPurchaseOrderLineItemInput!) {
  addPurchaseOrderLineItem(input: $input) {
    errors {
      code
      message
    }
    vendorPurchaseOrder {
      ...VendorPurchaseOrderFields
    }
  }
}
    fragment VendorPurchaseOrderFields on VendorPurchaseOrderDocument {
  created
  erpId
  id
  orderPlacedDate
  purchaseOrderNumber
  siteLocationId
  status
  tenantId
  updated
  vendorId
  vendorName
  isUrgent
  estimatedSubtotal
  estimatedTotal
  needByDate
  shipWeek
  notes
  billingAddress {
    ...AddressData
  }
  shippingAddress {
    ...AddressData
  }
  items {
    ...VendorPurchaseOrderItemFields
  }
  charges {
    ...VendorPurchaseOrderChargeFields
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment VendorPurchaseOrderItemFields on VendorPurchaseOrderItemData {
  erpJobId
  eventDetailId
  id
  isCostOverridden
  isOrganicAtReceive
  itemName
  lineNumber
  materialItemErpId
  materialItemId
  organicLotCode
  productionJobId
  productionJobNumber
  quantityOrdered
  quantityReceived
  unitCost
  unitCostText
  varianceReason
}
fragment VendorPurchaseOrderChargeFields on VendorPurchaseOrderChargeData {
  id
  label
  amount
}`);
export const AmendPurchaseOrderLineItemDocument = new TypedDocumentString(`
    mutation AmendPurchaseOrderLineItem($input: AmendPurchaseOrderLineItemInput!) {
  amendPurchaseOrderLineItem(input: $input) {
    errors {
      code
      message
    }
    vendorPurchaseOrder {
      ...VendorPurchaseOrderFields
    }
  }
}
    fragment VendorPurchaseOrderFields on VendorPurchaseOrderDocument {
  created
  erpId
  id
  orderPlacedDate
  purchaseOrderNumber
  siteLocationId
  status
  tenantId
  updated
  vendorId
  vendorName
  isUrgent
  estimatedSubtotal
  estimatedTotal
  needByDate
  shipWeek
  notes
  billingAddress {
    ...AddressData
  }
  shippingAddress {
    ...AddressData
  }
  items {
    ...VendorPurchaseOrderItemFields
  }
  charges {
    ...VendorPurchaseOrderChargeFields
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment VendorPurchaseOrderItemFields on VendorPurchaseOrderItemData {
  erpJobId
  eventDetailId
  id
  isCostOverridden
  isOrganicAtReceive
  itemName
  lineNumber
  materialItemErpId
  materialItemId
  organicLotCode
  productionJobId
  productionJobNumber
  quantityOrdered
  quantityReceived
  unitCost
  unitCostText
  varianceReason
}
fragment VendorPurchaseOrderChargeFields on VendorPurchaseOrderChargeData {
  id
  label
  amount
}`);
export const RemovePurchaseOrderLineItemDocument = new TypedDocumentString(`
    mutation RemovePurchaseOrderLineItem($input: RemovePurchaseOrderLineItemInput!) {
  removePurchaseOrderLineItem(input: $input) {
    errors {
      code
      message
    }
    vendorPurchaseOrder {
      ...VendorPurchaseOrderFields
    }
  }
}
    fragment VendorPurchaseOrderFields on VendorPurchaseOrderDocument {
  created
  erpId
  id
  orderPlacedDate
  purchaseOrderNumber
  siteLocationId
  status
  tenantId
  updated
  vendorId
  vendorName
  isUrgent
  estimatedSubtotal
  estimatedTotal
  needByDate
  shipWeek
  notes
  billingAddress {
    ...AddressData
  }
  shippingAddress {
    ...AddressData
  }
  items {
    ...VendorPurchaseOrderItemFields
  }
  charges {
    ...VendorPurchaseOrderChargeFields
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment VendorPurchaseOrderItemFields on VendorPurchaseOrderItemData {
  erpJobId
  eventDetailId
  id
  isCostOverridden
  isOrganicAtReceive
  itemName
  lineNumber
  materialItemErpId
  materialItemId
  organicLotCode
  productionJobId
  productionJobNumber
  quantityOrdered
  quantityReceived
  unitCost
  unitCostText
  varianceReason
}
fragment VendorPurchaseOrderChargeFields on VendorPurchaseOrderChargeData {
  id
  label
  amount
}`);
export const ConfirmReceiptDocument = new TypedDocumentString(`
    mutation ConfirmReceipt($input: ConfirmReceiptInput!) {
  confirmReceipt(input: $input) {
    errors {
      code
      message
    }
    vendorPurchaseOrder {
      ...VendorPurchaseOrderFields
    }
  }
}
    fragment VendorPurchaseOrderFields on VendorPurchaseOrderDocument {
  created
  erpId
  id
  orderPlacedDate
  purchaseOrderNumber
  siteLocationId
  status
  tenantId
  updated
  vendorId
  vendorName
  isUrgent
  estimatedSubtotal
  estimatedTotal
  needByDate
  shipWeek
  notes
  billingAddress {
    ...AddressData
  }
  shippingAddress {
    ...AddressData
  }
  items {
    ...VendorPurchaseOrderItemFields
  }
  charges {
    ...VendorPurchaseOrderChargeFields
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment VendorPurchaseOrderItemFields on VendorPurchaseOrderItemData {
  erpJobId
  eventDetailId
  id
  isCostOverridden
  isOrganicAtReceive
  itemName
  lineNumber
  materialItemErpId
  materialItemId
  organicLotCode
  productionJobId
  productionJobNumber
  quantityOrdered
  quantityReceived
  unitCost
  unitCostText
  varianceReason
}
fragment VendorPurchaseOrderChargeFields on VendorPurchaseOrderChargeData {
  id
  label
  amount
}`);
export const AddVendorPurchaseOrderChargeDocument = new TypedDocumentString(`
    mutation AddVendorPurchaseOrderCharge($input: AddVendorPurchaseOrderChargeInput!) {
  addVendorPurchaseOrderCharge(input: $input) {
    errors {
      code
      message
    }
    vendorPurchaseOrder {
      ...VendorPurchaseOrderFields
    }
  }
}
    fragment VendorPurchaseOrderFields on VendorPurchaseOrderDocument {
  created
  erpId
  id
  orderPlacedDate
  purchaseOrderNumber
  siteLocationId
  status
  tenantId
  updated
  vendorId
  vendorName
  isUrgent
  estimatedSubtotal
  estimatedTotal
  needByDate
  shipWeek
  notes
  billingAddress {
    ...AddressData
  }
  shippingAddress {
    ...AddressData
  }
  items {
    ...VendorPurchaseOrderItemFields
  }
  charges {
    ...VendorPurchaseOrderChargeFields
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment VendorPurchaseOrderItemFields on VendorPurchaseOrderItemData {
  erpJobId
  eventDetailId
  id
  isCostOverridden
  isOrganicAtReceive
  itemName
  lineNumber
  materialItemErpId
  materialItemId
  organicLotCode
  productionJobId
  productionJobNumber
  quantityOrdered
  quantityReceived
  unitCost
  unitCostText
  varianceReason
}
fragment VendorPurchaseOrderChargeFields on VendorPurchaseOrderChargeData {
  id
  label
  amount
}`);
export const RemoveVendorPurchaseOrderChargeDocument = new TypedDocumentString(`
    mutation RemoveVendorPurchaseOrderCharge($input: RemoveVendorPurchaseOrderChargeInput!) {
  removeVendorPurchaseOrderCharge(input: $input) {
    errors {
      code
      message
    }
    vendorPurchaseOrder {
      ...VendorPurchaseOrderFields
    }
  }
}
    fragment VendorPurchaseOrderFields on VendorPurchaseOrderDocument {
  created
  erpId
  id
  orderPlacedDate
  purchaseOrderNumber
  siteLocationId
  status
  tenantId
  updated
  vendorId
  vendorName
  isUrgent
  estimatedSubtotal
  estimatedTotal
  needByDate
  shipWeek
  notes
  billingAddress {
    ...AddressData
  }
  shippingAddress {
    ...AddressData
  }
  items {
    ...VendorPurchaseOrderItemFields
  }
  charges {
    ...VendorPurchaseOrderChargeFields
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment VendorPurchaseOrderItemFields on VendorPurchaseOrderItemData {
  erpJobId
  eventDetailId
  id
  isCostOverridden
  isOrganicAtReceive
  itemName
  lineNumber
  materialItemErpId
  materialItemId
  organicLotCode
  productionJobId
  productionJobNumber
  quantityOrdered
  quantityReceived
  unitCost
  unitCostText
  varianceReason
}
fragment VendorPurchaseOrderChargeFields on VendorPurchaseOrderChargeData {
  id
  label
  amount
}`);
export const UpdateVendorPurchaseOrderMetadataDocument = new TypedDocumentString(`
    mutation UpdateVendorPurchaseOrderMetadata($input: UpdateVendorPurchaseOrderMetadataInput!) {
  updateVendorPurchaseOrderMetadata(input: $input) {
    errors {
      code
      message
    }
    vendorPurchaseOrder {
      ...VendorPurchaseOrderFields
    }
  }
}
    fragment VendorPurchaseOrderFields on VendorPurchaseOrderDocument {
  created
  erpId
  id
  orderPlacedDate
  purchaseOrderNumber
  siteLocationId
  status
  tenantId
  updated
  vendorId
  vendorName
  isUrgent
  estimatedSubtotal
  estimatedTotal
  needByDate
  shipWeek
  notes
  billingAddress {
    ...AddressData
  }
  shippingAddress {
    ...AddressData
  }
  items {
    ...VendorPurchaseOrderItemFields
  }
  charges {
    ...VendorPurchaseOrderChargeFields
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment VendorPurchaseOrderItemFields on VendorPurchaseOrderItemData {
  erpJobId
  eventDetailId
  id
  isCostOverridden
  isOrganicAtReceive
  itemName
  lineNumber
  materialItemErpId
  materialItemId
  organicLotCode
  productionJobId
  productionJobNumber
  quantityOrdered
  quantityReceived
  unitCost
  unitCostText
  varianceReason
}
fragment VendorPurchaseOrderChargeFields on VendorPurchaseOrderChargeData {
  id
  label
  amount
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    ReceiveVendorPurchaseOrderItems: build.mutation<ReceiveVendorPurchaseOrderItemsMutation, ReceiveVendorPurchaseOrderItemsMutationVariables>({
      query: (variables) => ({ document: ReceiveVendorPurchaseOrderItemsDocument, variables })
    }),
    CreateVendorPurchaseOrder: build.mutation<CreateVendorPurchaseOrderMutation, CreateVendorPurchaseOrderMutationVariables>({
      query: (variables) => ({ document: CreateVendorPurchaseOrderDocument, variables })
    }),
    SetPurchaseOrderUrgent: build.mutation<SetPurchaseOrderUrgentMutation, SetPurchaseOrderUrgentMutationVariables>({
      query: (variables) => ({ document: SetPurchaseOrderUrgentDocument, variables })
    }),
    UpdateVendorPurchaseOrderSiteLocation: build.mutation<UpdateVendorPurchaseOrderSiteLocationMutation, UpdateVendorPurchaseOrderSiteLocationMutationVariables>({
      query: (variables) => ({ document: UpdateVendorPurchaseOrderSiteLocationDocument, variables })
    }),
    ApprovePurchaseOrder: build.mutation<ApprovePurchaseOrderMutation, ApprovePurchaseOrderMutationVariables>({
      query: (variables) => ({ document: ApprovePurchaseOrderDocument, variables })
    }),
    ShipPurchaseOrder: build.mutation<ShipPurchaseOrderMutation, ShipPurchaseOrderMutationVariables>({
      query: (variables) => ({ document: ShipPurchaseOrderDocument, variables })
    }),
    CancelPurchaseOrder: build.mutation<CancelPurchaseOrderMutation, CancelPurchaseOrderMutationVariables>({
      query: (variables) => ({ document: CancelPurchaseOrderDocument, variables })
    }),
    ChangeVendorPurchaseOrderStatus: build.mutation<ChangeVendorPurchaseOrderStatusMutation, ChangeVendorPurchaseOrderStatusMutationVariables>({
      query: (variables) => ({ document: ChangeVendorPurchaseOrderStatusDocument, variables })
    }),
    AddPurchaseOrderLineItem: build.mutation<AddPurchaseOrderLineItemMutation, AddPurchaseOrderLineItemMutationVariables>({
      query: (variables) => ({ document: AddPurchaseOrderLineItemDocument, variables })
    }),
    AmendPurchaseOrderLineItem: build.mutation<AmendPurchaseOrderLineItemMutation, AmendPurchaseOrderLineItemMutationVariables>({
      query: (variables) => ({ document: AmendPurchaseOrderLineItemDocument, variables })
    }),
    RemovePurchaseOrderLineItem: build.mutation<RemovePurchaseOrderLineItemMutation, RemovePurchaseOrderLineItemMutationVariables>({
      query: (variables) => ({ document: RemovePurchaseOrderLineItemDocument, variables })
    }),
    ConfirmReceipt: build.mutation<ConfirmReceiptMutation, ConfirmReceiptMutationVariables>({
      query: (variables) => ({ document: ConfirmReceiptDocument, variables })
    }),
    AddVendorPurchaseOrderCharge: build.mutation<AddVendorPurchaseOrderChargeMutation, AddVendorPurchaseOrderChargeMutationVariables>({
      query: (variables) => ({ document: AddVendorPurchaseOrderChargeDocument, variables })
    }),
    RemoveVendorPurchaseOrderCharge: build.mutation<RemoveVendorPurchaseOrderChargeMutation, RemoveVendorPurchaseOrderChargeMutationVariables>({
      query: (variables) => ({ document: RemoveVendorPurchaseOrderChargeDocument, variables })
    }),
    UpdateVendorPurchaseOrderMetadata: build.mutation<UpdateVendorPurchaseOrderMetadataMutation, UpdateVendorPurchaseOrderMetadataMutationVariables>({
      query: (variables) => ({ document: UpdateVendorPurchaseOrderMetadataDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useReceiveVendorPurchaseOrderItemsMutation, useCreateVendorPurchaseOrderMutation, useSetPurchaseOrderUrgentMutation, useUpdateVendorPurchaseOrderSiteLocationMutation, useApprovePurchaseOrderMutation, useShipPurchaseOrderMutation, useCancelPurchaseOrderMutation, useChangeVendorPurchaseOrderStatusMutation, useAddPurchaseOrderLineItemMutation, useAmendPurchaseOrderLineItemMutation, useRemovePurchaseOrderLineItemMutation, useConfirmReceiptMutation, useAddVendorPurchaseOrderChargeMutation, useRemoveVendorPurchaseOrderChargeMutation, useUpdateVendorPurchaseOrderMetadataMutation } = injectedRtkApi;
